import { DEFAULT_SERVICES_CMS } from '../cms/defaultSiteContent';

/** Service offerings for the contact form — stays aligned with default CMS cards (ids + titles). */
export function getI3ContactServiceOptions(): { value: string; label: string }[] {
  const options: { value: string; label: string }[] = [];
  for (const pillar of DEFAULT_SERVICES_CMS.pillars) {
    for (const card of pillar.cards) {
      options.push({ value: card.id, label: card.title });
    }
  }
  return options;
}
